<form [formGroup]="form" [patchForm]="selectedFilters$ | async">
  <h4 [hidden]="filterIsSelected$ | async">
    {{ 'general.selectAFilter' | translate }}
    <div
      class="spinner-border spinner-border-sm ms-2"
      role="status"
      *ngIf="isLoading$ | async"
      attr.aria-label="{{ 'general.loading' | translate }}"
    >
    </div>
  </h4>

  <div class="row gx-2">
    <div class="col-md-6 mb-3">
      <label class="form-label">
        {{ 'bookingModule.selectResource' | translate }}
      </label>
      <product-select-input-multiple
        [products]="bookableProducts$ | async"
        formControlName="selectedBookableProductIds"
        [allowClearing]="true"
        (search)="onSearchProducts($event)"
        [dataTestId]="'booking-bookable-multiple-select'"
      ></product-select-input-multiple>
    </div>
    <div class="col-md-6 mb-3">
      <label class="form-label">
        {{ 'bookingModule.selectResourceGroup' | translate }}
      </label>
      <product-select-input-multiple
        (search)="onSearchProductGroups($event)"
        [products]="productGroups$ | async"
        formControlName="selectedProductGroupIds"
        [allowClearing]="true"
        [dataTestId]="'booking-locations-multiple-select'"
      ></product-select-input-multiple>
    </div>
  </div>
  <day-selector
    class="mb-4"
    [startDate]="defaultStarDay"
    [markDisableYearCalendarDates]="true"
    [stickyToday]="false"
    [maxNumberOfDaysToShow]="7"
    [bookingId]="bookingId"
    (onDaySelected)="onDaySelected($event)"
  ></day-selector>

  <schedule
    [selectedDay]="selectedDay$ | async"
    [bookableSlots$]="bookableSlots$"
    [bookingId]="bookingId"
    [targetedProductsIds$]="targetProductsIds$"
    [showOnlySelectedProductIds]="true"
    [configChanges$]="scheduleConfig$"
    (onClickBookableSlot)="onClickEvent($event)"
    (clickSlot)="onSlotClick($event)"
  >
  </schedule>
  <div class="mt-2">
    <i role="img" class="fa fa-check me-1 ms-3 small" aria-hidden="true"></i
    >{{ 'participationModule.isConfirmed' | translate }}
    <i role="img" class="fa fa-question me-1 ms-3 small" aria-hidden="true"></i>
    {{ 'participationModule.isUnconfirmed' | translate }}
    <i role="img" class="fa fa-users me-1 ms-3 small" aria-hidden="true"></i
    >{{ 'general.full' | translate }}
    <i role="img" class="fa fa-clock me-1 ms-3 small" aria-hidden="true"></i
    >{{ 'general.empty' | translate }}
    <span class="">
      <span
        class="legend-square bg-light dependant-product-style-start dependant-product-style-end ms-3"
      ></span>
      {{ 'productModule.dependantProducts' | translate }}
    </span>
  </div>
</form>
